import { IoDocumentText } from "react-icons/io5";

const AppraisalReviewDetails = ({
  item,
  showDocument = true,
  peerReviewAffectsScore,
  upwardReviewAffectsScore,
  crossReviewAffectsScore,
}) => {
  return (
    <>
      <div className="flex mb-3 space-x-6">
        {item?.appraisalType > 1 && (
          <h3
            className="text-xss font-semibold text-gray-500 
                     uppercase tracking-wide w-1/4"
          >
            {item?.appraisalType > 1 ? "360° Appraisal Applied ? " : null}
          </h3>
        )}
        <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide w-3/4">
          {(item?.appraisalType === 0 && "Self Review") ||
            (item?.appraisalType === 1 && "Line Manager Review") ||
            (item?.appraisalType === 2 && "Peer Review") ||
            (item?.appraisalType === 3 && "Upward Review") ||
            (item?.appraisalType === 4 && "Cross Review")}
        </h3>
      </div>

      {/* KRA Actual Value */}
      <div className="flex items-start mb-4 space-x-6">
        <p className="font-semibold text-gray-700 w-1/4">Score:</p>
        <p className="text-gray-700 3/4">{item.kraActualScore}</p>
      </div>

      {/* Comment */}
      <div className="flex items-start mb-4 space-x-6">
        <p className="font-semibold text-gray-700 w-1/4">Comment :</p>
        <p className="text-gray-700 w-3/4">{item?.comment}</p>
      </div>
      <div className="flex items-start mb-4 space-x-6">
        <p className="font-semibold text-gray-700 w-1/4">
          peerReviewAffectsScore:
        </p>
        <p className="text-gray-700 w-3/4">
          {peerReviewAffectsScore ? "Yes" : "No"}
        </p>
      </div>
      <div className="flex items-start mb-4 space-x-6">
        <p className="font-semibold text-gray-700 w-1/4">
          upwardReviewAffectsScore:
        </p>
        <p className="text-gray-700 w-3/4">
          {upwardReviewAffectsScore ? "Yes" : "No"}
        </p>
      </div>
      <div className="flex items-start mb-4 space-x-6">
        <p className="font-semibold text-gray-700 w-1/4">
          crossReviewAffectsScore:
        </p>
        <p className="text-gray-700 w-3/4">
          {crossReviewAffectsScore ? "Yes" : "No"}
        </p>
      </div>

      {/* Attachment */}
      {showDocument && (
        <div className="flex items-start space-x-6">
          <p className="text-sm font-semibold text-gray-400 w-1/4">
            Attachment
          </p>
          <div className="grid grid-cols-2 gap-6">
            {item?.documents?.map((document, index) => {
              const mimeType = document.fileType?.includes("/")
                ? document.fileType
                : `application/${document.fileType}`;
              const fileURL = `data:${mimeType};base64,${document.base64Content}`;

              const handleOpen = () => {
                const newTab = window.open();
                newTab.document.write(
                  `<iframe src="${fileURL}" width="100%" height="100%"></iframe>`
                );
              };

              return (
                <button
                  key={index}
                  onClick={handleOpen}
                  className="text-blue-600 flex space-x-1 items-center text-sm font-medium hover:underline "
                >
                  <IoDocumentText className="w-10 h-10  text-blue-600" />
                  <p>{document?.fileName} </p>
                </button>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};
export default AppraisalReviewDetails;
